/*
 * @Author: wulan
 * @Date: 2021-09-Tu 04:09:47
 * @Last Modified by: wulan
 * @decs:用户登录相关信息
 */

import { getLocalStorage } from '@/utils/localStorage'

// 用户是否登录
export const getIsLogin = () => {
  return !!getLocalStorage('ticket')
}

// 获取用户ticket
export const getTicket = () => {
  return getLocalStorage('ticket')
}
